//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: ${({ direction = "column" }) => direction};
    gap: 12px;
    align-items: ${({ 
        direction = "column" 
    }) => (
        direction === "column" ? "flex-start" : "center")};
    & > h4 { 
        font-size: 16px;
        color: var(--dark-4);
        margin: 0;
    }
    & > span[data-role="description"] { 
        font-size: 14px;
        color: var(--light-gray-5);
    }
    &.mini {
        gap: 3px;
        & > h4, span[data-role="description"] { 
            font-size: 12px;
            color: var(--dark-4);
        }
    }
`;

export const ContainerPublicListFileDataField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    & span, & a {
        font-size: 14px;
    }
    & span {
        color: var(--light-gray-5);
    }
    & a {
        color: var(--purple-2);
    }
`;